export class NumberConstants {
  public static readonly ADDRESS_MAX_LENGTH = 30;
  public static readonly ADDRESS_TWO_MAX_LENGTH = 30;
  public static readonly STATE_MAX_LENGTH = 20;
  public static readonly CITY_MAX_LENGTH = 20;
  public static readonly ZIP_MAX_LENGTH = 9;
  public static readonly PASSWORD_MAX_LENGTH = 32;

  ///Should update AppValidator.firstNamePattern and AppValidator.lastNamePattern, if first and last name values are changed
  public static readonly FIRST_NAME_MAX_LENGTH = 20;
  public static readonly LAST_NAME_MAX_LENGTH = 20;

  public static readonly PROJECT_NAME_MAX_LENGTH = 40;
  public static readonly PROJECT_DESCRIPTION_MAX_LENGTH = 250;

  public static readonly PROJECT_ITEM_HEADING_MAX_LENGTH = 40;
  public static readonly PROJECT_ITEM_DESCRIPTION_MAX_LENGTH = 250;

  public static readonly ADDRESS_MIN_LENGTH = 3;
  public static readonly ADDRESS_TWO_MIN_LENGTH = 3;
  public static readonly STATE_MIN_LENGTH = 3;
  public static readonly CITY_MIN_LENGTH = 3;
  public static readonly ZIP_MIN_LENGTH = 5;
  public static readonly FIRST_NAME_MIN_LENGTH = 3;
  public static readonly LAST_NAME_MIN_LENGTH = 1;
  public static readonly PASSWORD_MIN_LENGTH = 8;
}
